export function getTranslation(lang: string): {
    back: string;
} {
    const translationStrings = {
        en: {
            back: 'Back'
        },
        es: {
            back: 'Atrás'
        }
    }
    return translationStrings[lang];
}
